import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Visit';

const routes = [
    {
        matchRegex: '/Visit/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'part-used-unit', label: 'Part Used Unit' },
            ],

            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-part-used-header', label: 'Tab Parts - Table "Part Used" header' },
                { key: 'table-part-used-body', label: 'Tab Parts - Table "Part Used" body' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity', label: 'Part Used Quantity' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_UPDATE_PART_USED_LINE_SUCCESS',
                    label: 'Tab Parts - After Update Part Used Line Success',
                },
                {
                    key: 'MARKETPLACE_EVENT_DELETE_PART_USED_LINE_SUCCESS',
                    label: 'Tab Parts - After Delete Part Used Line Success',
                },
                {
                    key: 'MARKETPLACE_EVENT_FETCH_PART_USED_LIST_SUCCESS',
                    label: 'Tab Parts - Fetch part used list success',
                },
            ],
        },
    },
]

export default routes;